export const SignalingAuthorityRender = (params: any) => {
    const { row } = params
    return (
        <span>{row?.signalingAuthority} ({row?.signalingAuthorityContact})</span>
    )
}
